import { baseApi } from '@shared/api';
import { ICountry } from '..';

export const countryApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getCountries: build.query<ICountry[], void>({
      query: () => ({
        url: '/countries',
      }),
    }),
  }),
});

export const { useGetCountriesQuery } = countryApi;
